import React, { useState, useEffect } from "react";
import axios from "axios";
import SearchIcon from "@mui/icons-material/Search";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import { useNavigate } from "react-router-dom";
import filterIcon from "../../../Icons/filterIcon.png";
import ExcelExport from "../../../components/ExcelExport/ExcelExportAccounts";


const EmployeeExpenseDetail = () => {
    const [userDetailResponse, setUserDetailResponse] = useState([]);
    const [expenseDetailResponse, setExpenseDetailResponse] = useState([''])
    const navigate = useNavigate();
    const baseAPI = process.env.REACT_APP_API_URL;

    useEffect(() => {
        EmplyeeDetail();

    }, []);

   

    function EmplyeeDetail() {
        const storedToken = JSON.parse(localStorage.getItem("token"));
        if (storedToken) {
            axios
                .get(`${baseAPI}adminget/GETEmployee?employeeID=&desg_id=0&dept_id=0&region_id=0&meal_Preference=&status=&location=`, {
                    headers: {
                        Authorization: `Bearer ${storedToken}`,
                    },
                })
                .then((response) => {
                    // console.log("employeresponse",response)
                    setUserDetailResponse(response.data.data);
                })
                .catch((error) => {
                    console.error("Error fetching user detail:", error);
                });
        }
    }

    return (
        <div>
            <div className="app-container-viewLeadDetails">
                <MiniDrawer />
                <div
                    style={{ overflowX: "hidden" }}
                    className="container-fluid container-viewLeadDetails"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "1rem",
                        }}
                        className="country-header"
                    >
                        <div>
                            <h1 style={{ fontSize: "24px" }}>
                                <b> Statement of Accounts </b> | <HomeOutlinedIcon /> &gt;
                                <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate("")}
                                >
                                    Accounts & Finance{" "}
                                </a>
                                <span style={{ fontSize: "20px" }}>&gt; Reports</span>{" "}
                                <span style={{ fontSize: "20px" }}>
                                    &gt; Statement
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div>
                        <div className="container-fluid px-3 py-2">
                            <div className='mt-2' style={{ display: "flex", justifyContent: "space-between" }}>
                                <button className="filterButton">
                                    <img src={filterIcon} /> FILTER
                                </button>
                            </div>
                            <hr
                                style={{ marginTop: "20px", padding: "0px", marginBottom: "30px" }}
                            />
                            <div className="expenseList">
                                <h2
                                    className="Venderheading"
                                    style={{
                                        fontSize: "22px",
                                        paddingLeft: "16px",
                                        paddingTop: "7px",
                                    }}
                                >
                                    Employee Detail
                                </h2>
                                <table style={{ width: "100%" }} className="table_expense">
                                    <thead>
                                        <tr className="expenseListHeading">
                                            <th>S No.</th>
                                            <th>Name</th>
                                            <th>Department</th>
                                            <th>Designation</th>                                            
                                            <th>Email</th>
                                            <th>Emp Code</th>
                                            <th>Mobile</th>
                                            <th>Status</th>
                                            <th>Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {userDetailResponse !== null ? (
                                            userDetailResponse.map((expense, index) => (
                                                <>
                                                    <tr key={index + 1}>
                                                        <td>{index + 1}</td>
                                                        <td>{expense.name}</td>
                                                        <td>{expense.department}</td>
                                                        <td>{expense.designation}</td>
                                                        <td>{expense.email}</td>
                                                        <td>{expense.emp_code}</td>
                                                        <td>{expense.phoneNo}</td>
                                                        <td>{expense.is_active}</td>
                                                        
                                                        
                                                        <td style={{textAlign: 'center',}} >
                                                            <button className="text-center" style={{
                                                                border: "none",
                                                                width: "37px",
                                                                padding: "0px",
                                                                height: "36px",
                                                                margin: '6px',
                                                                backgroundColor: "#F1F1F1", color: "#6a6a6a", border: "none",
                                                                
                                                            }}
                                                            
                                                            onClick={() => navigate("/EmployeeExpenseDetailList", {
                                                                state: { customer_id: expense.customer_id }
                                                            })}
                                                            title="View Details"                                                          
                                                            >
                                                                <SearchIcon />
                                                            </button>
                                                        </td>
                                                    </tr>                                                    
                                                </>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="9">No expenses available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav
                                    aria-label="Page navigation"
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        marginTop: "1rem",
                                    }}
                                >
                                    <ul className="pagination">
                                        <li className="page-item">
                                            <a style={{ cursor: "pointer", fontWeight: 'bold', color: '#5B489D' }}
                                                className="page-link"
                                            >
                                                Previous
                                            </a>
                                        </li>

                                        <li style={{ backgroundColor: '#5B489D' }} className="page-item active">
                                            <a style={{ backgroundColor: '#5B489D', border: 'none' }} className="page-link">1</a>
                                        </li>
                                        <li className="page-item">
                                            <a style={{ cursor: "pointer", color: '#5B489D' }}
                                                className="page-link"
                                            >
                                                2
                                            </a>
                                        </li>
                                        <li className="page-item">
                                            <a style={{ cursor: "pointer", color: '#5B489D', fontWeight: 'bold' }}
                                                className="page-link"
                                            >
                                                Next
                                            </a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                    {/* ------------------------customer deatil--------------------- */}
                </div>
            </div>
        </div>
    )
}

export default EmployeeExpenseDetail;

